import {
    Box,
    Drawer,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import "./Sidebar.css";
import HistoryIcon from '@mui/icons-material/History';
import InventoryIcon from '@mui/icons-material/Inventory';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import AssignmentIcon from '@mui/icons-material/Assignment';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import LogoutIcon from '@mui/icons-material/Logout';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import { Home, MonetizationOn } from '@mui/icons-material';
import { Button } from 'rsuite';
import { useState } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { clearUserData } from '../redux/slices/userDataSlice'
import relaxwellLogo from '../assets/relaxwell_logo.png';


const Sidebar = () => {
    const navigate = useNavigate();
    const [open, setOpen] = useState(true);
    const toggleDrawer = () => setOpen(!open);
    const userDetails = useSelector((state: RootState) => state.user.user);
    const dispatch = useDispatch();

    const handleLogout = async () => {
        dispatch(clearUserData())
        navigate('/login');
        console.log("logout sidebar clicked")
    }

    const menuItems = [
        // { label: 'Home', icon: <Home className="sidebar-icons" />, onClick: () => navigate('/dashboard'), visible: true },
        { label: 'QR Generation', icon: <InventoryIcon className="sidebar-icons" />, onClick: () => navigate('/qr-generation'), visible: true },
        { label: 'QR History', icon: <HistoryIcon className="sidebar-icons" />, onClick: () => navigate('/qr-history'), visible: true },
        { label: 'Redemption', icon: <MonetizationOn className="sidebar-icons" />, onClick: () => navigate('/redemption'), visible: true },
        { label: 'Redemption History', icon: <ConfirmationNumberIcon className="sidebar-icons" />, onClick: () => navigate('/redemption-history'), visible: true },
        { label: 'Add User', icon: <PersonAddIcon className="sidebar-icons" />, onClick: () => navigate('/add-user'), visible: true },
        { label: 'KYC', icon: <VerifiedUserIcon className="sidebar-icons" />, onClick: () => navigate('/kyc'), visible: true },
        { label: 'Ticket', icon: <AssignmentIcon className="sidebar-icons" />, onClick: () => navigate('/ticket'), visible: true },
        { label: 'Scan History', icon: <QrCodeScannerIcon className="sidebar-icons" />, onClick: () => navigate('/scan-history'), visible: true },
    ].filter(item => item.visible);


    return (
        <Drawer
            variant="permanent"
            anchor="left"
            sx={{
                width: open ? 300 : 60,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: open ? 300 : 60,
                    boxSizing: 'border-box',
                },
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: open ? 'flex-end' : 'center',
                    p: 1,
                }}
            >
                {(open ?
                    <span className='sidebar-header'>

                        <Box
                            // onClick={() => navigate('/profile')}
                            sx={{
                                p: 2,
                                mr: 2,
                                borderRadius: 3,
                                // mt: 2,
                                display: 'flex',
                                alignItems: 'left',
                                cursor: 'pointer',
                                border: '2px solid',
                                borderColor: '#03509d',
                                gap: 1,
                            }}
                        >
                            <img src={relaxwellLogo} alt='relaxwell-logo' />
                        </Box>

                        <ChevronLeftIcon
                            onClick={toggleDrawer}
                            sx={{ cursor: 'pointer', color: '#03509d', alignItems: 'right', fontSize: '2rem' }}
                        />
                    </span>

                    :
                    <MenuIcon
                        onClick={toggleDrawer}
                        sx={{ cursor: 'pointer', color: '#03509d' }}
                    />
                )}
            </Box>

            {/* {open && (

            )} */}
            <List>
                {menuItems
                    .map(({ label, icon, onClick }) => (
                        <ListItemButton key={label} onClick={onClick} sx={{ justifyContent: open ? 'flex-start' : 'center' }}>
                            <ListItemIcon sx={{ minWidth: 0, mr: open ? 2 : 'auto', justifyContent: 'center' }}>
                                {icon}
                            </ListItemIcon>
                            {open && <ListItemText primary={label} />}
                        </ListItemButton>
                    ))}
            </List>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mt: 2,
                }}
            >
                {open && (<Button
                    id='logout-button'
                    onClick={handleLogout}
                >
                    <LogoutIcon />
                    Logout
                </Button>
                )}
            </Box>

        </Drawer>
    );
};

export default Sidebar;
